// extracted by mini-css-extract-plugin
export default {"wrapper":"I2","how_often":"J2","box":"K2","scoops":"L2"};
    if(module.hot) {
      // 1713969939039
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  